import { HttpContext, HttpContextToken } from '@angular/common/http';

export const SKIP_AUTH_REDIRECT = new HttpContextToken<boolean>(() => false);

export function skipAuthRedirect(): HttpContext {
  return new HttpContext().set(SKIP_AUTH_REDIRECT, true);
}
